<template>
    <div>
        <div class="header clearfix" :class="{on: navOn, border: winTop>10}">
            <div class="inner clearfix">
                <div class="header-logo">
                    <router-link v-if="!navOn" to="/"><img src="@/assets/images/logo.png"></router-link>
                    <router-link v-else to="/"><img src="@/assets/images/logo-white.png"></router-link>
                </div>
                <div class="header-tips">数字化体验新集成商</div>
                <div class="header-nav-btn" @click="toggleNav">
                    <span class="header-nav-btn-icon_t"></span>
                    <span class="header-nav-btn-icon_m"></span>
                    <span class="header-nav-btn-icon_b"></span>
                </div>
                <!-- <div class="hearder-search">
                    <input class="hearder-search-input" type="text" name="header-search" placeholder="搜索">
                    <a class="hearder-search-btn"></a>
                </div> -->
                <TheHeaderNav :navOn="navOn" @closeNav="closeNav" />
            </div>
        </div>
    </div>
</template>
<script>
import TheHeaderNav from '@/components/module/TheHeaderNav'

import jquery from 'jquery'
import wx from 'wx'



export default {
    name: 'TheHeader',
    props: {

    },
    components: {
        TheHeaderNav
    },
    data: function() {
        return {
            path: this.$route.path,
            navOn: false,
            winTop: 0
        }
    },
    mounted: function() {
        this.getWintop();
        this.setShare();
    },
    methods: {
        toggleNav: function() {
            this.navOn = !this.navOn;
        },
        getWintop: function() {
            let that = this;
            window.onscroll = function() {
                // console.log(window.pageXOffset);
                // alert("检测到页面滚动事件:"+window.pageXOffset+" "+window.pageYOffset);
                // console.log(document.documentElement.scrollTop);
                that.winTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset;
                console.log();
            };
        },
        closeNav: function() {
            this.navOn = false;
        },
        setShare: function() {
                        //微信分享
            var datas = {
                title: "喜得, 是一家创新设计公司",
                desc: "数字化体验新集成商",
                url: location.href,
                imgUrl: 'https://www.xidespace.com/images/200200.jpg?v=1',
            }
            this.share(datas);
        },
        share: function(datas) {
            /*
             分享
             */
            //success: to share
            function encode(url) {
                return encodeURIComponent(url).replace(/'/g, "%27").replace(/"/g, "%22");
            }

            var surl = datas.url ? datas.url : window.location.href;
            var url = "https://wxapi.xidework.com/jsSdk/jsApi?url=" + encode(surl);
            var callback = function(json) {
                var data = json.content;
                wx.config({
                    debug: false,
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo']
                });

                wx.ready(function() {
                    var shareData = {
                        title: datas.title,
                        desc: datas.desc,
                        link: surl, // 分享链接
                        imgUrl: datas.imgUrl,
                        success: function() {
                            // 用户确认分享后执行的回调函数
                            // alert('分享成功')
                            console.log('share')
                        }
                    };

                    //分享朋友
                    wx.updateAppMessageShareData(shareData)
                    //分享朋友圈
                    wx.updateTimelineShareData(shareData)
                    //分享微博
                    wx.onMenuShareWeibo(shareData)

                });
                wx.error(function(res) {
                    console.log(res.errMsg);
                });
            };
            jquery.ajax({
                url: url,
                dataType: "jsonp",
                jsonp: "jsoncallback",
                success: function(response) {
                    callback && callback(response);
                },
                error: function(xhr, type) {
                    console.log('xhr:' + xhr + "type:" + type);
                    console.log("网络错误请重试")
                }
            })
        }
    },
    activated() {
        this.navOn = false;
        this.getWintop();
    },
    deactivated() {
        this.navOn = false;
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@media*/
</style>